var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isImage)?_c('img',{attrs:{"alt":_vm.alt,"src":_vm.icon,"size":_setup.sizeInPixel,"width":_setup.sizeInPixel,"height":_setup.sizeInPixel}}):_c(_setup.VIcon,{staticClass:"icon",attrs:{"color":_vm.color,"size":_setup.sizeInPixel}},[_vm._v(_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }